import { lazy } from 'react';
import { Navigate, RouteProps } from 'react-router-dom';
import PatientDetails from '../components/ui/PatientDetails';
import { appPages, authPages } from '../config/pages.config';
import ProtectedRoute from '../context/ProtectedRoutes';
import ForgotPasswordPage from '../pages/ForgotPassword.page';
import LoginPage from '../pages/Login.page';
import NotFoundPage, { RedirectToNotFound } from '../pages/NotFound.page';
import { CalendarDate } from '../pages/patient/Calendar';
import NewNoteCase from '../pages/patient/NewNoteCase';
import PatientForm from '../pages/patient/PatientForm';
import PatientPage from '../pages/patient/PatientPage';
import SoapDetails from '../pages/patient/SoapDetails';
import ProfilePage from '../pages/profile/Profile.page';
import ResetPasswordPage from '../pages/ResetPassword.page';
import SignupPage from '../pages/Signup.page';
import SubscriptionPage from '../pages/subscription/Subscription.page';
import VerifyEmailPage from '../pages/VerifyEmail.page';
import UserForm from '../pages/patient/UserForm';
import FoundationPlaceholder from '../new-ui/pages/FoundationPlaceholder';
import Dashboard from '../new-ui/pages/Dashboard';
import Patients from '../new-ui/pages/Patients';
import PatientDetail from '../new-ui/pages/PatientDetail';
import PatientNoteDetail from '../new-ui/pages/PatientNoteDetail';
import ProfileSettings from '../new-ui/pages/ProfileSettings';

/**
 * SALES
 */
const SalesDashboardPage = lazy(
	() => import('../pages/sales/SalesDashboardPage/SalesDashboard.page'),
);

/**
 * Other
 */
const UnderConstructionPage = lazy(() => import('../pages/UnderConstruction.page'));

const contentRoutes: RouteProps[] = [
	{
		path: appPages.dashboardPage.to,
		element: <ProtectedRoute element={<Navigate to='/patients' replace />} />,
	},
	{
		path: appPages.subscriptionPage.to,
		element: <SubscriptionPage />,
	},
	{
		path: appPages.profilePage.to,
		element: <ProtectedRoute element={<ProfileSettings />} />,
	},
	{
		path: appPages.patientPage.to,
		element: <Navigate to='/patients' replace />,
	},
	{
		path: appPages.patientForm.to,
		element: <ProtectedRoute element={<UserForm />} />,
	},
	{
		path: `${appPages.patientPage.to}/case/:id`,
		element: <ProtectedRoute element={<PatientPage />} />,
	},
	{
		path: `${appPages.patientPage.to}/case`,
		element: <ProtectedRoute element={<PatientPage />} />,
	},
	// The following form routes are kept for backward compatibility
	// Forms are now integrated directly into the SOAP note view for better user experience
	{
		path: '/patients/:patientId/cases/:caseId/form',
		element: <ProtectedRoute element={<PatientForm />} />,
	},
	{
		path: '/patients/:patientId/cases/:caseId/form/:routeNoteId',
		element: <ProtectedRoute element={<PatientForm />} />,
	},
	{
		path: '/patients/:patientId/cases/:caseId/new-note-case',
		element: <ProtectedRoute element={<NewNoteCase />} />,
	},
	{
		path: '/patients/cases/new-note-case/:type',
		element: <ProtectedRoute element={<NewNoteCase />} />,
	},
	{
		path: '/patients/:patientId/cases/:caseId/soap/:soapId',
		element: <ProtectedRoute element={<SoapDetails />} />,
	},
	// {
	// 	path: appPages.addPatientPage.to,
	// 	element: <AddPatientPage />,
	// },
	{ path: authPages.loginPage.to, element: <LoginPage /> },
	{ path: authPages.signupPage.to, element: <SignupPage /> },
	{ path: authPages.forgotPasswordPage.to, element: <ForgotPasswordPage /> },
	{ path: authPages.resetPasswordPage.to, element: <ResetPasswordPage /> },
	{ path: authPages.verifyEmailPage.to, element: <VerifyEmailPage /> },
	{ path: authPages.notFoundPage.to, element: <NotFoundPage /> },
	{ path: authPages.recordingDemo.to, element: <ProtectedRoute element={<CalendarDate />} /> },

	{ path: '/patients/:id/notes/:noteId', element: <ProtectedRoute element={<PatientNoteDetail />} /> },
	{ path: '/patients/:id', element: <ProtectedRoute element={<PatientDetail />} /> },
	{ path: '/patients', element: <ProtectedRoute element={<Patients />} /> },
	{ path: '/app', element: <ProtectedRoute element={<Dashboard />} /> },
	{ path: '*', element: <RedirectToNotFound /> },
];

export default contentRoutes;
